export enum Section {
    RBC = 'RBC',
    IRON = 'Iron',
    WBC = 'WBC',
    PLATELETS = 'Platelets',
    GLUCOSE = 'Glucose',
    KIDNEY = 'Kidney',
    NUTRIENTS = 'Nutrients',
    ELECTROLYTES = 'Electrolytes',
    PROTEINS = 'Proteins',
    LIVER_BILIARY = 'Liver / Biliary',
    LIPIDS = 'Lipids',
    INFLAMMATION_OXIDATIVE_STRESS = 'Inflammation / Oxidative Stress',
    THYROID = 'Thyroid',
    SEX_HORMONE = 'Hormones',
    STRESS_ADRENAL = 'Stress & Adrenal Balance',
    PROSTATE = 'Prostate',
    ABOVE_OPTIMAL = 'Above Optimal',
    BELOW_OPTIMAL = 'Below Optimal',
    NEEDS_ATTENTION = 'Alarm Range Markers',
    WORTH_DISCUSSING = 'Outside Lab Range Markers',
    FINE_TUNE = 'Outside Optimal Range Markers',
    MARKERS_OUTSIDE_OPTIMAL = 'Markers Outside Optimal',
    RESULTS_OVERVIEW = 'Results Overview',
    SUPPLEMENTS = 'Supplements',
    NOTES = 'Notes',
    BMI = 'BMI'
}
